var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const FlagStart = (_a) => {
    var { color = '#695CFF', fill = 'none', width = 18, height = 32 } = _a, props = __rest(_a, ["color", "fill", "width", "height"]);
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M13.9797 7.50545L2.20733 2.47273V1.09091C2.20733 0.494545 1.707 0 1.10366 0C0.500327 0 0 0.494545 0 1.09091V30.9091C0 31.5055 0.500327 32 1.10366 32C1.707 32 2.20733 31.5055 2.20733 30.9091V22.24L14.3035 16.3345C14.3035 16.3345 14.3035 16.3345 14.3182 16.3345C16.761 15.0836 18.0706 13.4691 17.9971 11.7673C17.9235 10.0655 16.4961 8.55273 13.9797 7.50545Z", fill: "#695CFF" })));
};
export default FlagStart;
